const api = `${process.env.PUBLIC_URL}/api`;
export const TaskApi = `${api}/task.json`;
export const BookmarkApi = `${api}/bookmark.json`;
export const ChartistApi = `${api}/chartistData.json`;
export const ChartjsApi = `${api}/chartjsData.json`;
export const ChatMemberApi = `${api}/chatMember.json`;
export const ChatApi = `${api}/chat.chats.json`;
export const ContactApi = `${api}/contacts.json`;
export const ProductsApi = `${api}/product.json`;
export const EmailApi = `${api}/email.json`;
export const ImageLightApi = `${api}/image-light.json`;
export const BigImageApi = `${api}/image-big-light.json`;
export const MasonryApi = `${api}/masonry.json`;
export const GooglechartApi = `${api}/googleChartData.json`;
export const AllProjectApi = `${api}/allProject.json`;
export const SearchAllTabsApi = `${api}/searchAllTabs.json`;
export const TableDataApi = `${api}/tableData.json`;
export const HoverableRowsTable = `${api}/hoverableRowsTable.json`;
export const TodoApi = `${api}/todo.json`;
export const JobSearchApi = `${api}/jobSearch.json`;
export const LearningApi = `${api}/learning.json`;
export const KnowledgebaseApi = `${api}/knowledgebaseDB.json`;
export const FaqApi = `${api}/Faq.json`;
export const FileApi = `${api}/files.json`;
export const UserCardApi = `${api}/usercard.json`;
export const UserEditTableAPI = `${api}/user-edit-table.json`;
export const StickyApi = `${api}/sticky.json`;
export const TypeaheadDataApi = `${api}/typeaheadData.json`;
export const FeatherDataApi = `${api}/featherData.json`;
export const FlagIconDataApi = `${api}/flagIconData.json`;
export const FontawsomeDataApi = `${api}/fontawsomeData.json`;
export const IcoDataApi = `${api}/icoData.json`;
export const ThemifyDataApi = `${api}/themifyData.json`;


//AUth
//login
export const Login = "postlogin"


// General Settings
//doctor department
export const DoctorDepartmentList = "doctor_departments"
export const CreateDoctorDepartment = "doctor_department_add"
export const UpdateDoctorDepartment = "update_doctor_department"
export const DeleteDoctorDepartment = "delete_doctor_department"

//Inventory Category
export const InventoryCategoryList = "inventory_category_list"
export const CreateInventoryCategory = "store_inventory_category"
export const UpdateInventoryCategory = "update_inventory_category"
export const DeleteInventoryCategory = "delete_inventory_category"

//Medical Report Type Category
export const CreateMedicalReportType = "storeMedicalcategory"
export const UpdateMedicalReportType = "updateMedicalcategory"
export const MedicalReportTypeList = "medicalCategoryList"
export const DeleteMedicalReportType = "deleteMedicalcategory"

//Pharmacy Category
export const PharmacyCategoryList = "pharmacy_category_list"
export const CreatePharmacyCategory = "store_pharmacy_category"
export const UpdatePharmacyCategory = "update_pharmacy_category"
export const DeletePharmacyCategory = "delete_pharmacy_category"

//Staff Category
export const StaffCategoryList = "staff_category_list"
export const CreateStaffCategory = "store_staff_category"
export const UpdateStaffCategory = "update_staff_category"
export const DeleteStaffCategory = "delete_staff_category"

//Treatment Settings
// diagnosis type
export const DiagnosisType = "diagnosistypeList"
export const AddDiagnosisType = "storediagnosistype"
export const UpdateDiagnosisType = "updatediagnosistype"
export const DeleteDiagnosisType = "deletediagnosistype"

//Diagnosis
export const DiagnosisList = "diagnosisList"
export const CreateDiagnosis = "storediagnosis"
export const UpdateDiagnosis = "updatediagnosis"
export const DeleteDiagnosis = "deletediagnosis"

//Tratment Plan TreatmentPlan
export const TreatmentPlanList = "treatmentList"
export const CreateTreatmentPlan = "storetreatment"
export const UpdateTreatmentPlan = "updateTreatmentList"
export const DeleteTreatmentPlan = "delete_subcategory"

//Tratment Procedure TreatmentPlan
export const TreatmentProcedureList = "treatmentProcedureList"
export const CreateTreatmentProcedure = "storetreatmentProcedure"
export const UpdateTreatmentProcedure = "updatetreatmentProcedure"
export const DeleteTreatmentProcedure = "deletetreatmentProcedure"


//Tratment Method TreatmentPlan
export const TreatmentMethodList = "treatmentmethodList"
export const CreateTreatmentMethod = "storetreatmentmethod"
export const UpdateTreatmentMethod = "updatetreatmentmethod"
export const DeleteTreatmentMethod = "deletetreatmentmethod"


//Pharmacy
export const PharmacyList = "prescriptionsubCategoryList"
export const CreatePharmacy = "storetprescriptionsubCategory"
export const UpdatePharmacy = "updatetprescriptionsubCategory"
export const DeletePharmacy = "deletetprescriptionsubCategory"

//Inventory
export const InventoryList = "inventory_list"
export const CreateInventory = "store_inventory"
export const UpdateInventory = "update_inventory"
export const DeleteInventory = "delete_inventory"

//Doctor
export const DoctorList = 'doctor_list'
export const CreateDoctor = 'store_doctor'
export const UpdateDocor  = 'update_doctor'
export const DeleteDoctor = 'delete_doctor'

//Staff
export const StaffList = 'staff_list'
export const CreateStaff = 'store_staff'
export const UpdateStaff  = 'update_staff'
export const DeleteStaff = 'delete_staff'

//Staff
export const PatientList = 'patient_list'
export const CreatePatient = 'store_patient'
export const UpdatePatient  = 'update_patient'
export const DeletePatient = 'delete_patient'

//General Medical Record

export const GeneralMedicalRecord = 'store_medical_record'
export const GeneralMedicalRecordList = 'medical_record_list'

// Treatment Plan Map
export const CreateTreatmentPlanMapping ='store_treatment_plan_mapping'
export const TreatmentPlanMappingList = 'treatment_plan_mapping_list'
export const UpdateTreatmentPlanMapping = 'update_treatment_plan_mapping'
export const DeleteTreatmentPlanMapping = 'delete_treatment_plan_mapping'

// store_appointment

export const CreateAppointment = 'store_appointment'
export const AppointmentList = 'appointment_list'
export const RescheduleAppointment = 'reschedule_appointment'
export const NextAppointment = 'next_appointment_v2'
export const AppointmentStatus = 'appointment_status_update'

// Medical Report
export const CreateMedicalReport = "savePatientMedicalReport"
export const MedicalreportList = "getPatientMedicalReport"
export const DeleteMedicalReport = "deletePatientMedicalReport"

//Upcoming Appointments and Scheduled
export const UpcomingAppointmentList = "upcoming_appointments_v2"
export const ScheduledList = "appointment_list"

//Patient Prescription
export const PatientPrescriptionList = 'patient_prescription_list_mapping'
export const CreatePatientPrescription = 'store_patient_prescription'
export const UpdatePatientPrescription = 'update_patient_prescription'
export const DeletePatientPrescription = 'delete_patient_prescription'
export const AddPatientPrescriptionPayment = 'store_prescription_Payments'
export const EditPatientPrescriptionPayment = 'update_prescription_Payments'


// Accounts - income
export const listClinicPayment = "acc_method_payment"
export const ListPharmacyIncome = "acc_prescription_payment"  
export const NetProfitList = "accountslist"

// Accounts - expense
export const StorePharmacyExpenses = "store_pharmacy_account"
export const ListPharmacyExpenses = "list_pharmacy_account"
export const DeletePharmacyExpenses = "pharmacy_account_delete"
export const UpdatePharmacyExpenses = "update_pharmacy_account"


export const StoreOthersExpenses = "store_stationery_account"
export const ListOthersExpenses = "list_stationery_account"
export const DeleteOthersExpenses = "stationery_account_delete"
export const UpdateOthersExpenses = "update_stationary_account"


export const StoreLabExpenses = "store_lab_account"
export const UpdateLabExpenses = "update_lab_account"
export const ListLabExpenses = "list_lab_account"
export const DeleteLabExpenses = "lab_account_delete"

export const StoreExpenses = "store_inventory_account"
export const ListExpenses = "list_inventory_account"
export const UpdateExpenses = "update_inventory_account"
export const DeleteExpenses = "inventory_account_delete"

export const ListSalary = 'list_salaries'
export const StoreStaffSalary = 'store_staff_salary'
export const StoreDoctorSalary = 'store_doctor_salary'
export const UpdateSalary = "update_salary"
export const DeleteSalary = "delete_salary"

// Consultant and Payments
export const StoreConsultantPayment = "store_consultant_payment"
export const UpdateConsultantPayment = "update_consultant_payment"
export const ListConsultantExpenses = "acc_treatment_plan_method"


// Patient Treatment Payment
export const AppointmentPaymentList = "list_payment_trans"
export const TreatmentPayment = "store_payment_trans"
export const EditTreatmentPayment = 'update_payment_trans'


// Enquiry and Notification
export const StoreInquiry = "store_enquiry"
export const NotificationList = "get_notificationsList"
export const InquiryList = "get_enquiry_list"
// export const OpInquiry = "get_out_patient_enquiry_list"
export const ChangeInStatus = "change_enquiry_status"
// export const ChangeStatusOp = "change_out_patient_enquiry_status"
export const ChangeStatus = "change_notification_status"

// User Profile

export const ProfileUpdate = 'admin_profile'
export const ProfileChangePassword = 'patient_change_password'

// Forget Password
export const ForgetPassword = "forgot_password"
export const ForgetVerfiyOtp = "forgotverifyOtp"
export const ForgetChangePassword = "forgot_change_pw"

export const PatientRegistration = 'patient_registration'

// User Management

export const ReadRole = 'viewrole'
export const CreateRolePermission = 'createRolePermission'
export const ReadRolePermission = 'readRolePermission'
